<template>
  <div>
    <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white">
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
              All Grade Results
            </h6>
            <h2 class="text-blueGray text-xl font-semibold">
              Current Grade Results of Student Delay
            </h2>

          </div>
        </div>
      </div>
      <div class="p-4 flex-auto ">
        <div class="flex flex-wrap">
          <!--- Doctor of Medicine Program -->
          <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full  mb-4 shadow-md rounded-lg border-0"
            style="background-color: #D6E2ED;">
            <div class="flex flex-wrap items-center pb-4">
              <span class="text-blueGray text-lg font-semibold text-blueGray">
                Doctor of Medicine Program
              </span>
              <div class="relative w-full max-w-full flex-grow flex-1 text-right">
                <button @click="toggleAccordion(26)" class="accordion-header cursor-pointer text-sm shadow-lg
                text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
                mb-1 ease-linear transition-all duration-150" type="button" style="background-color: #2E476B;">
                  Show All</button>
              </div>
            </div>

            <div class="block lg:overflow-hidden overflow-x-auto w-full max-h-400-px shadow rounded-lg"
              v-if="showAccordion[26]">
              <table
                class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white text-sm">
                <thead class="sticky top-0">
                  <tr>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Class Year
                    </th>
                    <th
                      class="lg:w-350-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Subject
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      A
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      X
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      E
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      I
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      G
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      P
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      F
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      Total
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      Extend
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      View Detail
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="smartgrade_med_arr.length === 0">
                    <td colspan="15" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(smartgrade_med, index) in smartgrade_med_arr" :key="index">
                    <td class="max-w-50-px border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.class_year }}
                    </td>
                    <td class="lg:w-350-px border-t-0 px-6 p-2 align-top border-l-0 border-r-0  text-left">
                      {{ smartgrade_med.subject_name + " (" + smartgrade_med.credit + " Credit)" }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.A }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.Bplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.B }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.Cplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.C }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_med.X > 0 }">
                      {{ smartgrade_med.X }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_med.E > 0 }">
                      {{ smartgrade_med.E }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_med.I > 0 }">
                      {{ smartgrade_med.I }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.G }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.P }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_med.F > 0 }">
                      {{ smartgrade_med.F }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_med.num_student }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      <div v-if="smartgrade_med.extend_status === 1"
                        class="text-center inline-flex items-center justify-center mb-5 text-emerald-600">
                        <i class="fa fa-check"></i>
                      </div>
                      <div v-else class="text-center inline-flex items-center justify-center mb-5 text-red-500">
                        <i class="fa fa-times"></i>
                      </div>
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      <div class="text-center inline-flex items-center justify-center mb-5"
                        v-on:click="toggleModal(smartgrade_med.mid, smartgrade_med.subject_name)"
                        style="color: #6187B8;">
                        <i class="fa fa-search"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--- Bachelor of Science (Radiological Technology) -->
          <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full mb-4 shadow-md rounded-lg border-0"
            style="background-color: #D6E2ED;">
            <div class="flex flex-wrap items-center pb-4">
              <span class="text-blueGray text-lg font-semibold text-blueGray">
                Bachelor of Science (Radiological Technology)
              </span>
              <div class="relative w-full max-w-full flex-grow flex-1 text-right">
                <button @click="toggleAccordion(28)" class="accordion-header cursor-pointer text-sm shadow-lg
                text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
                mb-1 ease-linear transition-all duration-150" type="button" style="background-color: #2E476B;">
                  Show All</button>
              </div>
            </div>

            <div class="block w-full overflow-x-auto max-h-400-px shadow rounded-lg" v-if="showAccordion[28]">
              <table
                class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white text-sm">
                <thead class="sticky top-0">
                  <tr>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Class Year
                    </th>
                    <th
                      class="lg:w-350-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Subject
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      A
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      X
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      E
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      I
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      G
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      P
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      F
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      Total
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      View Detail
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="smartgrade_radio_arr.length === 0">
                    <td colspan="15" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(smartgrade_radio, index) in smartgrade_radio_arr" :key="index">
                    <td class="max-w-50-px border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.class_year }}
                    </td>
                    <td class="lg:w-350-px border-t-0 px-6 p-2 align-top border-l-0 border-r-0  text-left">
                      {{ smartgrade_radio.subject_name + " (" + smartgrade_radio.credit + " Credit)" }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.A }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.Bplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.B }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.Cplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.C }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_radio.X > 0 }">
                      {{ smartgrade_radio.X }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_radio.E > 0 }">
                      {{ smartgrade_radio.E }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_radio.I > 0 }">
                      {{ smartgrade_radio.I }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.G }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.P }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_radio.F > 0 }">
                      {{ smartgrade_radio.F }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_radio.num_student }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      <div class="text-center inline-flex items-center justify-center mb-5"
                        v-on:click="toggleModal(smartgrade_radio.mid, smartgrade_radio.subject_name)"
                        style="color: #6187B8;">
                        <i class="fa fa-search"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--- Bachelor of Science (Physical Therapy) -->
          <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full mb-4 shadow-md rounded-lg border-0"
            style="background-color: #D6E2ED;">
            <div class="flex flex-wrap items-center pb-4">
              <span class="text-blueGray text-lg font-semibold text-blueGray">
                Bachelor of Science (Physical Therapy)
              </span>
              <div class="relative w-full max-w-full flex-grow flex-1 text-right">
                <button @click="toggleAccordion(29)" class="accordion-header cursor-pointer text-sm shadow-lg
                text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
                mb-1 ease-linear transition-all duration-150" type="button" style="background-color: #2E476B;">
                  Show All</button>
              </div>
            </div>

            <div class="block w-full overflow-x-auto max-h-400-px shadow rounded-lg" v-if="showAccordion[29]">
              <table
                class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white text-sm">
                <thead class="sticky top-0">
                  <tr>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Class Year
                    </th>
                    <th
                      class="lg:w-350-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Subject
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      A
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      X
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      E
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      I
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      G
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      P
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      F
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      Total
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      View Detail
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="smartgrade_therapy_arr.length === 0">
                    <td colspan="15" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(smartgrade_therapy, index) in smartgrade_therapy_arr" :key="index">
                    <td class="max-w-50-px border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.class_year }}
                    </td>
                    <td class="lg:w-350-px border-t-0 px-6 p-2 align-top border-l-0 border-r-0  text-left">
                      {{ smartgrade_therapy.subject_name + " (" + smartgrade_therapy.credit + " Credit)" }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.A }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.Bplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.B }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.Cplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.C }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_therapy.X > 0 }">
                      {{ smartgrade_therapy.X }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_therapy.E > 0 }">
                      {{ smartgrade_therapy.E }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_therapy.I > 0 }">
                      {{ smartgrade_therapy.I }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.G }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.P }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_therapy.F > 0 }">
                      {{ smartgrade_therapy.F }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_therapy.num_student }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      <div class="text-center inline-flex items-center justify-center mb-5"
                        v-on:click="toggleModal(smartgrade_therapy.mid, smartgrade_therapy.subject_name)"
                        style="color: #6187B8;">
                        <i class="fa fa-search"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--- Bachelor of Science (Emergency Medical Operation) -->
          <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full shadow-md rounded-lg border-0"
            style="background-color: #D6E2ED;">
            <div class="flex flex-wrap items-center pb-4">
              <span class="text-blueGray text-lg font-semibold text-blueGray">
                Bachelor of Science (Emergency Medical Operation)
              </span>
              <div class="relative w-full max-w-full flex-grow flex-1 text-right">
                <button @click="toggleAccordion(30)" class="accordion-header cursor-pointer text-sm shadow-lg
                text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
                mb-1 ease-linear transition-all duration-150" type="button" style="background-color: #2E476B;">
                  Show All</button>
              </div>
            </div>

            <div class="block w-full overflow-x-auto max-h-400-px shadow rounded-lg" v-if="showAccordion[30]">
              <table
                class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white text-sm">
                <thead class="sticky top-0">
                  <tr>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Class Year
                    </th>
                    <th
                      class="lg:w-350-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      Subject
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      A
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      B
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C+
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      C
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      X
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      E
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      I
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      G
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      P
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      F
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0  font-semibold text-white"
                      style="background-color: #6187B8;">
                      Total
                    </th>
                    <th class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-white"
                      style="background-color: #6187B8;">
                      View Detail
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="smartgrade_er_arr.length === 0">
                    <td colspan="15" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(smartgrade_er, index) in smartgrade_er_arr" :key="index">
                    <td class="max-w-50-px border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.class_year }}
                    </td>
                    <td class="lg:w-350-px border-t-0 px-6 p-2 align-top border-l-0 border-r-0  text-left">
                      {{ smartgrade_er.subject_name + " (" + smartgrade_er.credit + " Credit)" }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.A }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.Bplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.B }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.Cplus }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.C }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_er.X > 0 }">
                      {{ smartgrade_er.X }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_er.E > 0 }">
                      {{ smartgrade_er.E }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_er.I > 0 }">
                      {{ smartgrade_er.I }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.G }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.P }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center"
                      :class="{ 'bg-red-200 font-semibold': smartgrade_er.F > 0 }">
                      {{ smartgrade_er.F }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      {{ smartgrade_er.num_student }}
                    </td>
                    <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                      <div class="text-center inline-flex items-center justify-center mb-5"
                        v-on:click="toggleModal(smartgrade_er.mid, smartgrade_er.subject_name)" style="color: #6187B8;">
                        <i class="fa fa-search"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

    </div>

    <ModalDetailGrade ref="modal_grade" />
  </div>
</template>

<script>
import api from './../../services/student_services';
import ModalDetailGrade from "@/components/Cards/ModalDetailGrade.vue";

export default {
  name: "large-modal",
  data() {
    return {
      openTab: 1,
      course: {
        "course": '26'
      },
      showModal: false,
      smartgrade_med_arr: [],
      smartgrade_radio_arr: [],
      smartgrade_therapy_arr: [],
      smartgrade_er_arr: [],
      showAccordion: {
        26: true,
        28: false,
        29: false,
        30: false
      },
    }
  },
  components: {
    ModalDetailGrade
  },
  methods: {
    toggleModal: function (mid, subname) {
      // console.log(mid)
      this.$refs.modal_grade.showAlert({
        mid: mid,
        status: '2',
        subname: subname
      });
    },
    toggleAccordion(accordionNumber) {
      // กำหนดค่าให้กับคุณสมบัติที่เปิดหรือปิดของแต่ละ Accordion
      this.showAccordion[accordionNumber] = !this.showAccordion[accordionNumber];
      this.course = {
        "course": accordionNumber
      }
      api.smartgrade_report_delay(this.course).then(async (result) => {
        if (accordionNumber == "26") {
          this.smartgrade_med_arr = result.data;
        } else if (accordionNumber == "28") {
          this.smartgrade_radio_arr = result.data;
        } else if (accordionNumber == "29") {
          this.smartgrade_therapy_arr = result.data;
        } else if (accordionNumber == "30") {
          this.smartgrade_er_arr = result.data;
        }

      });
    },
    async smartgrade_report() {
      api.smartgrade_report_delay(this.course).then(async (result) => {
        this.smartgrade_med_arr = result.data;
      });
    },
  }, created: async function () {
    await this.smartgrade_report()
  },
}
</script>